var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "content-class": "casino-dialog-container",
        persistent: "",
        fullscreen: _vm.mobileBigAndBelow,
        "max-width": !_vm.mobileBigAndBelow ? "70%" : ""
      },
      model: {
        value: _vm.vModelCondition,
        callback: function($$v) {
          _vm.vModelCondition = $$v
        },
        expression: "vModelCondition"
      }
    },
    [
      _c("div", { staticClass: "buttons-container" }, [
        _c("div", {
          staticClass: "close iframe-btn",
          on: {
            click: function($event) {
              return _vm.closeDialog()
            }
          }
        })
      ]),
      _vm._v(" "),
      _vm.casinoLauncherDialogState
        ? _c("casino-launcher", {
            attrs: { gameData: _vm.casinoLauncherDialogState }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77483fe3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77483fe3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/igaming/partials/casinoLauncherDialog.vue
// module id = null
// module chunks = 